export default {
  customerLiffID: process.env.VUE_APP_CUSTOMER_LIFF_ID,
  staffLiffID: process.env.VUE_APP_STAFF_LIFF_ID
}
